import React, {ReactNode, useEffect} from 'react';

import {Analytics} from '../../services/analytics';
import {EventData} from '../../services/analytics/types';
import {trackBannerButtonClicked} from '../../util/navigation';
import {
  BANNER_VARIANTS,
  BannerButtonWrapper,
  BannerVariant,
  BannerWrapper,
} from './Banner.styles';

type Props = {
  button?: ReactNode;
  children?: ReactNode;
  className?: string;
  eventData?: EventData;
  style?: React.CSSProperties;
  variant?: BannerVariant;
  alignItems?: string;
};

type ButtonProps = Pick<Props, 'variant' | 'eventData'> & {
  link?: string;
  text?: ReactNode;
  onClick?: () => void;
};

export const BannerButton = React.memo(
  ({
    eventData,
    link,
    onClick,
    text,
    variant = BANNER_VARIANTS.INFO,
    ...props
  }: ButtonProps) => (
    <BannerButtonWrapper
      variant={variant}
      onClick={() => {
        if (eventData) {
          trackBannerButtonClicked(eventData);
        }
        // this banner button link always expects internal wandb doc links
        if (!onClick) {
          // eslint-disable-next-line wandb/no-unprefixed-urls
          window.open(link);
        } else {
          onClick();
        }
      }}
      {...props}>
      {text}
    </BannerButtonWrapper>
  )
);
BannerButton.displayName = 'BannerButton';

export const Banner = React.memo(
  ({eventData, variant = BANNER_VARIANTS.INFO, ...props}: Props) => {
    useEffect(() => {
      if (eventData) {
        Analytics.track('Banner Viewed', eventData ?? {});
      }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return <BannerWrapper variant={variant} {...props} />;
  }
);
Banner.displayName = 'Banner';
